export const host = process.env.REACT_APP_API_HOST || 'http://localhost:9000';

// Sliding expiry — backend's fetchuser middleware re-issues a fresh JWT on
// every authenticated request and surfaces it as `x-refreshed-token`. Call
// this after any authenticated fetch and the local token stays current,
// so the admin is never logged out while they're actively using the app.
export const applyRefreshedToken = (response) => {
  const fresh = response.headers.get('x-refreshed-token');
  if (fresh) localStorage.setItem('token', fresh);
};

// Canonical blog-title slug. ONE definition so link-builders and the
// detail-page lookup can never disagree. Lowercase, runs of non-
// alphanumerics collapse to a single '-' (preserves word boundaries
// so "Mercury Direct" → "mercury-direct" stays distinct from
// "MercuryDirect" → "mercurydirect"). Leading/trailing hyphens
// trimmed.
//
// Mirror of server/utils/slug.js — keep them byte-identical.
export const slugify = (title) =>
  (title || '')
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// Pre-hyphen slug format. Kept ONLY so that any external URL shared
// before the slug-format change ('/blog/x/mercurydirect') still
// resolves — BlogSpecificPage's lookup tries this as a final fallback.
// Safe to remove ~6 months after the migration runs in prod.
export const slugifyLegacy = (title) =>
  (title || '').toString().toLowerCase().trim().replace(/[^a-z0-9]+/g, '');
